<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de livro de medicamentos controlados">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'farmacia-livro-psicotropico-create' })"
                    authorize="store-farmacia-livro-psicotropico"
                    color="primary"
                >
                    Cadastrar livro
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List
                    :key="listKey"
                    @update="listKey++"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/farmacia/livro-psicotropico/List'

export default {
    components: { List },
    data: () => ({
        listKey: 1,
    }),
}
</script>